import React from 'react';
import { acceptConsultantInvite, getConsultantInvite } from '@api/consultantInvite';
import AcceptInvitePage from '@components/containers/invite/AcceptInvitePage';

/**
 * The consultant's way in. The page itself is shared with vendor invites - only the API pair,
 * the one line of copy and the landing route are this file's.
 */
const AcceptConsultantInvite: React.FC = () => (
    <AcceptInvitePage
        description="You've been invited to access Reparo as a consultant."
        fetchInvite={getConsultantInvite}
        accept={acceptConsultantInvite}
        landing="/"
    />
);

export default AcceptConsultantInvite;
